import {
  jb_section_headline_css_default
} from "./chunk.HUY27KB7.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-section-headline/jb-section-headline.ts
var JbSectionHeadline = class extends r {
  render() {
    return ke`<div class="${Rt({ left: this.headlineAlign === "left" })}">
      <h2>${this.headline}</h2>
      ${this.languageBadge ? ke`<span>${this.languageBadge}</span>` : D}
    </div>`;
  }
};
JbSectionHeadline.styles = jb_section_headline_css_default;
__decorateClass([
  n()
], JbSectionHeadline.prototype, "headline", 2);
__decorateClass([
  n()
], JbSectionHeadline.prototype, "headlineAlign", 2);
__decorateClass([
  n()
], JbSectionHeadline.prototype, "languageBadge", 2);
JbSectionHeadline = __decorateClass([
  customElement("jb-section-headline")
], JbSectionHeadline);

export {
  JbSectionHeadline
};
